<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { data1 } from './data'
import { HotTable } from '@handsontable/vue'
import Handsontable from 'handsontable'
import axios from 'axios'
import 'handsontable/dist/handsontable.full.css'
import 'handsontable/languages/es-MX'

export default {
  page: {
    title: 'Templates List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, HotTable },
  data() {
    return {
      title: 'Templates',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Templates',
          href: '/',
          active: true,
        },
        {
          text: 'List',
          active: true,
        },
      ],
      hotSettings: {
        licenseKey: 'non-commercial-and-evaluation',
        colHeaders: true,
        manualColumnMove: true,
        manualRowMove: true,
        manualColumnResize: true,
        stretchH: 'all',
        width: '100%',
        height: 610,
        rowHeights: 23,
        contextMenu: true,
        language: 'es-MX',
      },
      container: null,
      jsondata: null,
      jsonfields: {},
      nameFile: 'Id_CompanyUser_Equiment_BC-IMP_FCL.xls',
    }
  },
  computed: {},
  created() {
    let param_data = this.$route.params.data
    let headers = Object.keys(param_data[0])
    this.hotSettings.data = param_data
    let data = [ headers ]
    for (let r = 0; r < param_data.length; r++) {
      let row = []
      for (let h = 0; h < headers.length; h++) {
        const value = param_data[r][headers[h]]
        row.push( value ? value : null)
      }
      data.push(row)
    }
    this.hotSettings.data = data
  },
  mounted() {
    this.container = this.$refs.wrapper.hotInstance
  },
  methods: {
    imprime() {
      console.log(this.jsondata)
      console.log(this.jsonfields)
    },
    addRow() {
      this.container.alter('insert_row', this.jsondata.length)
    },
    downLoadFile() {
      this.$emit('donwloadExcel')
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">Resultado Final</h4>
            <div class="form-group row">
              <div class="col-md-2">
                <b-button variant="primary" @click="addRow" class="btn btn-primary form-control">
                  Add Row
                  <i class="uil uil-plus"></i>
                </b-button>
              </div>
              <div class="col-md-4">
                <a href="#">
                  <download-excel :data="hotSettings.data" :name="nameFile"></download-excel>
                </a>
              </div>
            </div>
            <!-- <button @click="imprime">que hay en data</button> -->
            <p class="text-muted font-13 mb-4"></p>
            <div class="row">
              <div class="mb-md-2 col-md-12">
                <hot-table ref="wrapper" :settings="hotSettings"></hot-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
